import { render } from "./LoginButton.vue?vue&type=template&id=7273ca06"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"
script.render = render

export default script